import { useEffect, useState } from 'react';
import { Feature } from '../../../types/features';
import { formatFeatureName } from '../../../utils/commonFunctions';
import AcademiaCheckboxField from '../../CommonComps/Inputs/AcademiaCheckboxField';
import AcademiaSearchInput from '../../CommonComps/Inputs/AcademiaSearchInput';

const RolePermissionTable = ({
  featureList,
  defaultPermissionValues,
  isReadOnly,
}: {
  featureList: Array<Feature>;
  defaultPermissionValues?: { [key: string]: any };
  isReadOnly?: boolean;
}) => {
  // integration of react hooks here
  const [localFeatureList, setLocalFeatureList] = useState<Array<Feature>>([]);
  const [searchText, setSearchText] = useState<string>('');

  // filtering feature list based on search text here
  useEffect(() => {
    setLocalFeatureList(
      featureList.filter((feature) =>
        searchText
          ? feature.name.toLowerCase().includes(searchText.toLowerCase())
          : feature
      )
    );
  }, [featureList, searchText]);

  // rendering role permission table component here
  return (
    <>
      <div className='border-2 border-dashed border-legal-dark-blue p-3 rounded-lg mb-3'>
        <AcademiaSearchInput
          searchText={searchText}
          setSearchText={setSearchText}
          inputLabel='Search Feature...'
        />
      </div>

      <div className='relative h-[400px] overflow-auto academia-scrollbar border-2 border-dashed border-legal-dark-blue rounded-lg'>
        <div className='min-w-[620px] sticky top-0 grid grid-cols-[250px_repeat(4,_minmax(0,_1fr))] text-center bg-base-white text-legal-dark-blue font-semibold [&>p:not(:last-child)]:border-r [&>p:not(:last-child)]:border-dashed [&>p:not(:last-child)]:border-legal-dark-blue [&>p]:py-1 border-b-2 border-legal-dark-blue border-dashed z-10'>
          <p>Feature Name</p>
          <p>CREATE</p>
          <p>READ</p>
          <p>UPDATE</p>
          <p>DELETE</p>
        </div>

        <div className='min-w-[620px]'>
          {localFeatureList.length ? (
            localFeatureList.map((feature, index) => (
              <div
                key={feature.id}
                className={`grid grid-cols-[250px_repeat(4,_minmax(0,_1fr))] text-center text-legal-dark-blue [&>div:not(:last-child)]:border-r [&>div:not(:last-child)]:border-dashed [&>div:not(:last-child)]:border-legal-dark-blue [&>div]:p-1 ${
                  index !== featureList.length - 1
                    ? 'border-b border-dashed border-legal-dark-blue'
                    : ''
                }`}
              >
                <div title={formatFeatureName(feature.name)}>
                  <p className='truncate'>{formatFeatureName(feature.name)}</p>
                </div>

                <div className='flex items-center justify-center'>
                  <AcademiaCheckboxField
                    title={
                      defaultPermissionValues &&
                      defaultPermissionValues[`${feature.name}_create`]
                        ? 'Cannot Deselect Default Permission!'
                        : isReadOnly
                        ? 'Please, check the extra privilege box to update!'
                        : undefined
                    }
                    variant={
                      defaultPermissionValues &&
                      defaultPermissionValues[`${feature.name}_create`]
                        ? 'secondary'
                        : 'primary'
                    }
                    name={`${feature.name}_create`}
                    isReadOnly={
                      defaultPermissionValues &&
                      defaultPermissionValues[`${feature.name}_create`]
                        ? defaultPermissionValues[`${feature.name}_create`]
                        : isReadOnly
                    }
                  />
                </div>

                <div className='flex items-center justify-center'>
                  <AcademiaCheckboxField
                    title={
                      defaultPermissionValues &&
                      defaultPermissionValues[`${feature.name}_read`]
                        ? 'Cannot Deselect Default Permission!'
                        : isReadOnly
                        ? 'Please, check the extra privilege box to update!'
                        : undefined
                    }
                    variant={
                      defaultPermissionValues &&
                      defaultPermissionValues[`${feature.name}_read`]
                        ? 'secondary'
                        : 'primary'
                    }
                    name={`${feature.name}_read`}
                    isReadOnly={
                      defaultPermissionValues &&
                      defaultPermissionValues[`${feature.name}_read`]
                        ? defaultPermissionValues[`${feature.name}_read`]
                        : isReadOnly
                    }
                  />
                </div>

                <div className='flex items-center justify-center'>
                  <AcademiaCheckboxField
                    title={
                      defaultPermissionValues &&
                      defaultPermissionValues[`${feature.name}_update`]
                        ? 'Cannot Deselect Default Permission!'
                        : isReadOnly
                        ? 'Please, check the extra privilege box to update!'
                        : undefined
                    }
                    variant={
                      defaultPermissionValues &&
                      defaultPermissionValues[`${feature.name}_update`]
                        ? 'secondary'
                        : 'primary'
                    }
                    name={`${feature.name}_update`}
                    isReadOnly={
                      defaultPermissionValues &&
                      defaultPermissionValues[`${feature.name}_update`]
                        ? defaultPermissionValues[`${feature.name}_update`]
                        : isReadOnly
                    }
                  />
                </div>

                <div className='flex items-center justify-center'>
                  <AcademiaCheckboxField
                    title={
                      defaultPermissionValues &&
                      defaultPermissionValues[`${feature.name}_delete`]
                        ? 'Cannot Deselect Default Permission!'
                        : isReadOnly
                        ? 'Please, check the extra privilege box to update!'
                        : undefined
                    }
                    variant={
                      defaultPermissionValues &&
                      defaultPermissionValues[`${feature.name}_delete`]
                        ? 'secondary'
                        : 'primary'
                    }
                    name={`${feature.name}_delete`}
                    isReadOnly={
                      defaultPermissionValues &&
                      defaultPermissionValues[`${feature.name}_delete`]
                        ? defaultPermissionValues[`${feature.name}_delete`]
                        : isReadOnly
                    }
                  />
                </div>
              </div>
            ))
          ) : (
            <p className='text-center mt-1 text-base-red'>No feature found!!</p>
          )}
        </div>
      </div>
    </>
  );
};

export default RolePermissionTable;
